import { Alert, Space } from 'antd';
import { PageHeader } from '@ant-design/pro-components';
import { useCompany } from '../../hooks/company';
import AiChatConfigCard from './systemConfig/AiChatConfigCard';
import AiChatToolsCard from './systemConfig/AiChatToolsCard';
import SchedulerStopHourCard from './systemConfig/SchedulerStopHourCard';

const SYSTEM_CONFIG_ALLOWED_USER_ID = 10000;

export default function SystemConfig() {
  const { currentUser } = useCompany();

  if (Number(currentUser?.id) !== SYSTEM_CONFIG_ALLOWED_USER_ID) {
    return null;
  }

  return (
    <PageHeader title="系统配置">
      <Alert
        type="info"
        showIcon
        message="说明"
        description="系统级配置仅 superadmin 指定账号可见。修改后立即生效，相关后台任务在下一批次循环时读取最新值。"
        style={{ marginBottom: 16 }}
      />
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <SchedulerStopHourCard />
        <AiChatConfigCard />
        <AiChatToolsCard />
      </Space>
    </PageHeader>
  );
}
